import { Button } from '@/components/ui';
import React, { FC } from 'react';
import { BUTTON_STYLES } from '@/components/ui/Buttons/utils';
import { useRouter } from '@/navigation';
import useLocale from '@/hooks/useLocale';
import {
  TypeLink_externalFields,
  TypeModalFields,
} from '@/core/generated-types';
import SubscriberShopModalWrapper from './SubscriberShopModalWrapper';
import { TypeSubscriberShopPageTranslations } from '@/utils/translations';
import { UniversalCta } from '../UniversalCta';
import buildShopSubdomainUrl from '@/utils/shopSubdomain';

interface PlayKitLimitModalProps extends TypeModalFields {
  isOpen: boolean;
  handleClose: () => void | Promise<void>;
  handleRemoveSequentialKits: () => Promise<void>;
  translations: TypeSubscriberShopPageTranslations;
}

const PlayKitsLimitModal: FC<PlayKitLimitModalProps> = ({
  isOpen,
  handleClose,
  handleRemoveSequentialKits,
  translations,
  ...props
}) => {
  const { primaryCta } = props;
  const { push } = useRouter();
  const primaryCtaFields = primaryCta?.fields as TypeLink_externalFields;
  const primaryCtaHref = _getLinkUrl(primaryCtaFields);
  const { keepShoppingCta } = translations;

  const primaryButton = primaryCta ? (
    <UniversalCta
      link={primaryCta}
      className="mb-4 h-auto w-full md:w-[300px]"
      onClick={async (e) => {
        e.preventDefault();
        await handleRemoveSequentialKits();
        push(primaryCtaHref);
      }}
    />
  ) : null;

  const secondaryButton = (
    <Button
      ctaText={keepShoppingCta}
      style={BUTTON_STYLES.secondary}
      classes="mb-4 h-auto w-full md:w-[300px]"
      onClick={handleClose}
    />
  );

  const ctaButtons = [primaryButton, secondaryButton].filter(Boolean);

  return (
    <SubscriberShopModalWrapper
      isOpen={isOpen}
      handleClose={handleClose}
      ctaButtons={ctaButtons}
      {...props}
    />
  );
};

function _getLinkUrl(ctaFields: TypeLink_externalFields) {
  const locale = useLocale();
  const { hasShopSubdomain, linkUrl } = ctaFields;
  const href = hasShopSubdomain
    ? buildShopSubdomainUrl(linkUrl, locale as string)
    : linkUrl;

  return href;
}

export default React.memo(PlayKitsLimitModal);
